import React, { Fragment } from "react";
import { Stack, Typography } from "@mui/material";
//Srcs
import "../../Style/dialogstyle.scss";
import ExpenseListComp from "./ExpenseListComp";

export default function ListAccountType({
  disbursementList,
  setDisbursementList,
  requireField,
  setRequireField,
}) {
  //============================ End list Expense ===============================

  const ListItems = disbursementList?.map((item) => {
    // console.log("item::", item);
    return (
      <Fragment key={item?.key}>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ paddingBottom: "30px" }}
        >
          <Stack direction="column" spacing={0.5} sx={{ width: "96%" }}>
            <Stack direction="row" spacing={1}>
              <Typography className="list-title-kh">ប្រភេទគណនី ៖</Typography>
              <Typography className="list-title-kh">
                {item?.accountTypeName}
              </Typography>
            </Stack>

            <ExpenseListComp
              mainItem={item}
              disbursementList={disbursementList}
              setDisbursementList={setDisbursementList}
              requireField={requireField}
              setRequireField={setRequireField}
            />
          </Stack>
        </Stack>
      </Fragment>
    );
  });

  return <div>{ListItems}</div>;
}
